import { ReactNode, useState } from "react";
// Contexts
import { MotivatorsProvider } from "@Motivators/context/Common/MotivatorsContext";

// Components
import PageLayer from "@Layouts/views/PageLayer";

type MotivatorsPageLayerProps = {
	WrappedComponent: () => JSX.Element;
	headerTitle: string;
	headerIcon: ReactNode;
	motivatorType: string;
};
export default function motivatorsPageLayer({ WrappedComponent, headerTitle, headerIcon, motivatorType }: MotivatorsPageLayerProps) {
	return function IncentivePageLayer() {
		const [title, setTitle] = useState(headerTitle);
		return (
			<MotivatorsProvider motivatorType={motivatorType} setTitle={setTitle}>
				<PageLayer title={title} icon={headerIcon}>
					<WrappedComponent />
				</PageLayer>
			</MotivatorsProvider>
		);
	};
}
